import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusExamFragment = { readonly __typename?: 'SyncableEpocusExam', readonly id: string, readonly encounterId: string, readonly examType: string, readonly worksheetSummary: unknown, readonly images: unknown, readonly status: string, readonly signedAt?: string | null, readonly signedByUserId?: string | null, readonly nonBillable: boolean, readonly nonBillableReason?: Types.EpocusNonBillableReason | null, readonly amendments: unknown, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusExamPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusExamInput;
}>;


export type SyncEpocusExamPullQuery = { readonly __typename?: 'Query', readonly pullEpocusExam: { readonly __typename?: 'PullEpocusExamResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusExam', readonly id: string, readonly encounterId: string, readonly examType: string, readonly worksheetSummary: unknown, readonly images: unknown, readonly status: string, readonly signedAt?: string | null, readonly signedByUserId?: string | null, readonly nonBillable: boolean, readonly nonBillableReason?: Types.EpocusNonBillableReason | null, readonly amendments: unknown, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncEpocusExamPushMutationVariables = Types.Exact<{
  input: Types.PushEpocusExamInput;
}>;


export type SyncEpocusExamPushMutation = { readonly __typename?: 'Mutation', readonly pushEpocusExam: { readonly __typename?: 'PushEpocusExamResult', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusExam', readonly id: string, readonly encounterId: string, readonly examType: string, readonly worksheetSummary: unknown, readonly images: unknown, readonly status: string, readonly signedAt?: string | null, readonly signedByUserId?: string | null, readonly nonBillable: boolean, readonly nonBillableReason?: Types.EpocusNonBillableReason | null, readonly amendments: unknown, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusExamFragmentDoc = gql`
    fragment WholeSyncableEpocusExam on SyncableEpocusExam {
  id
  encounterId
  examType
  worksheetSummary
  images
  status
  signedAt
  signedByUserId
  nonBillable
  nonBillableReason
  amendments
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusExamPullDocument = gql`
    query SyncEpocusExamPull($input: PullEpocusExamInput!) {
  pullEpocusExam(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusExam
    }
  }
}
    ${WholeSyncableEpocusExamFragmentDoc}`;

/**
 * __useSyncEpocusExamPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusExamPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusExamPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusExamPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusExamPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusExamPullQuery, SyncEpocusExamPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusExamPullQuery, SyncEpocusExamPullQueryVariables>(SyncEpocusExamPullDocument, options);
      }
export function useSyncEpocusExamPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusExamPullQuery, SyncEpocusExamPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusExamPullQuery, SyncEpocusExamPullQueryVariables>(SyncEpocusExamPullDocument, options);
        }
export type SyncEpocusExamPullQueryHookResult = ReturnType<typeof useSyncEpocusExamPullQuery>;
export type SyncEpocusExamPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusExamPullLazyQuery>;
export type SyncEpocusExamPullQueryResult = Apollo.QueryResult<SyncEpocusExamPullQuery, SyncEpocusExamPullQueryVariables>;
export const SyncEpocusExamPushDocument = gql`
    mutation SyncEpocusExamPush($input: PushEpocusExamInput!) {
  pushEpocusExam(input: $input) {
    rows {
      ...WholeSyncableEpocusExam
    }
  }
}
    ${WholeSyncableEpocusExamFragmentDoc}`;
export type SyncEpocusExamPushMutationFn = Apollo.MutationFunction<SyncEpocusExamPushMutation, SyncEpocusExamPushMutationVariables>;

/**
 * __useSyncEpocusExamPushMutation__
 *
 * To run a mutation, you first call `useSyncEpocusExamPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusExamPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEpocusExamPushMutation, { data, loading, error }] = useSyncEpocusExamPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusExamPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncEpocusExamPushMutation, SyncEpocusExamPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEpocusExamPushMutation, SyncEpocusExamPushMutationVariables>(SyncEpocusExamPushDocument, options);
      }
export type SyncEpocusExamPushMutationHookResult = ReturnType<typeof useSyncEpocusExamPushMutation>;
export type SyncEpocusExamPushMutationResult = Apollo.MutationResult<SyncEpocusExamPushMutation>;
export type SyncEpocusExamPushMutationOptions = Apollo.BaseMutationOptions<SyncEpocusExamPushMutation, SyncEpocusExamPushMutationVariables>;